var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3505_100047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 14.667C13.2654 14.667 13.5197 14.5616 13.7073 14.3741C13.8948 14.1866 14.0002 13.9322 14.0002 13.667C14.0002 13.4018 13.8948 13.1474 13.7073 12.9599C13.5197 12.7723 13.2654 12.667 13.0002 12.667C12.7349 12.667 12.4806 12.7723 12.2931 12.9599C12.1055 13.1474 12.0002 13.4018 12.0002 13.667C12.0002 13.9322 12.1055 14.1866 12.2931 14.3741C12.4806 14.5616 12.7349 14.667 13.0002 14.667ZM6.3335 14.667C6.59871 14.667 6.85307 14.5616 7.0406 14.3741C7.22814 14.1866 7.3335 13.9322 7.3335 13.667C7.3335 13.4018 7.22814 13.1474 7.0406 12.9599C6.85307 12.7723 6.59871 12.667 6.3335 12.667C6.06828 12.667 5.81393 12.7723 5.62639 12.9599C5.43885 13.1474 5.3335 13.4018 5.3335 13.667C5.3335 13.9322 5.43885 14.1866 5.62639 14.3741C5.81393 14.5616 6.06828 14.667 6.3335 14.667Z",
    fill: "#5fc56e",
    stroke: "#5fc56e",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 2.66683H14.6668L13.3335 10.0002M3.3335 2.66683L4.66683 10.0002H13.3335M3.3335 2.66683C3.22216 2.22216 2.66683 1.3335 1.3335 1.3335M13.3335 10.0002H3.48683C2.2975 10.0002 1.66683 10.5208 1.66683 11.3335C1.66683 12.1462 2.2975 12.6668 3.48683 12.6668H13.0002",
    stroke: "#5fc56e",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3505_100047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarNav);
export default __webpack_public_path__ + "static/media/Car-Nav.5ad33e72d360e5c156f8085faf2cab0b.svg";
export { ForwardRef as ReactComponent };